import { render } from 'preact'
import { App } from './components/App.jsx'
import ActionCard from './components/ActionCard.jsx'
import './index.css'
import './i18n'
import fomService from './services/fomService.js'
import dataProviderService from './services/dataProviderService.js'
import AppContext from './contexts/AppContext.jsx'
import { registerActionCardComponent } from './actionCardModule'

const urlParams = new URLSearchParams(window.location.search)
const name = urlParams.get([...urlParams.keys()].find(key => key.toLowerCase() === 'name'))
let playbookId = urlParams.get([...urlParams.keys()].find(key => key.toLowerCase() === 'playbookid'))
const showScore = urlParams.has([...urlParams.keys()].find(key => key.toLowerCase() === 'showscore'))
const email = urlParams.get([...urlParams.keys()].find(key => key.toLowerCase() === 'email'))
const theme = urlParams.get([...urlParams.keys()].find(key => key.toLowerCase() === 'theme'))

;(async () => {
  document.documentElement.classList.toggle(
    'dark',
    theme === 'dark' || (!theme && window.matchMedia('(prefers-color-scheme: dark)').matches),
  )
  try {
    if (playbookId) {
      // WebPlay mode (action card and settings are loaded from the playbook)

      render(
        <AppContext initialProps={{ urlParams, name, playbookId, showScore, email }}>
          <App />
        </AppContext>,
        document.getElementById('app'),
      )
    } else {
      // Standalone mode (action card is loaded from the specified file)
      const fileName = name || 'demo'
      const dataProvider = await dataProviderService.getByName(fileName, showScore)
      await registerActionCardComponent(dataProvider)
      render(<ActionCard></ActionCard>, document.getElementById('app'))
    }
  } catch (error) {
    console.error('Failed to initialize the app:', error)
  }
})()
